import Page from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { useLanguage } from 'context/AppContext';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { TurnaroundList } from './components/TurnaroundList';
import { TurnaroundListSearch } from './components/TurnaroundListSearch';
import theme from 'App.theme';
import { TurnaroundListFiltersButton } from './components/TurnaroundListFiltersButton';

export const TurnaroundListPage = () => {
  const lang = useLanguage()[0];

  const navigate = useNavigate();

  const onBackClick = useCallback(() => {
    // Navigate back to the previous page
    navigate(-1);
  }, [navigate]);

  return (
    <Page>
      <PageHeader title={lang.Routes.TurnaroundList} onBackClick={onBackClick} />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.layout.spacing.small,
          marginBottom: theme.layout.spacing.small,
        }}
      >
        <TurnaroundListSearch />

        <TurnaroundListFiltersButton />
      </div>

      <TurnaroundList />
    </Page>
  );
};
